// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TMDR","type":"styles_type__388fl","choices":"styles_choices__2VwM5"};